<template>
  <v-wait :for="loaderId">
    <template slot="waiting">
      <b-row>
        <b-col cols="12" class="d-flex justify-content-center">
          <half-circle-spinner />
        </b-col>
      </b-row>
    </template>
    <template>
      <b-row>
        <b-col
          xl="4"
          lg="6"
          md="6"
          sm="12"
          class="d-flex align-items-center justify-content-center"
        >
          <ico-statistics :data="icoStatistic" />
        </b-col>
        <b-col
          v-if="icoLocationStatistics"
          xl="4"
          lg="6"
          md="6"
          sm="12"
          class="d-flex align-items-center justify-content-center"
        >
          <usa-map-chart
            :chart-data="icoLocationStatistics"
            chart-title="Desired Location"
          />
        </b-col>
        <b-col
          v-for="(res, index) in icoChartsResults"
          xl="4"
          lg="6"
          md="6"
          sm="12"
          :key="res.id || index"
        >
          <div class="mx-auto h-100 shadow-none phairify-chart-card">
            <div v-if="res && res.chart_title">
              <h2
                class="v2_font-Source v2_font_size_20 v2_font_weight_semibold v2_color_black mb-0"
              >
                <span>{{ res.chart_title }}</span>
              </h2>
            </div>
            <b-card-body>
              <div v-if="res && (!res.results || !res.results.length)">
                <b-alert show variant="warning">
                  There are no ICOs for your specialty yet. Please check back
                  later.
                </b-alert>
              </div>
              <div v-else-if="res && res.insufficient">
                <b-alert show variant="warning">
                  There is not enough data to display
                </b-alert>
              </div>
              <div v-else-if="res">
                <chart-builder
                  :result="res"
                  format="job-question"
                  :comparison="{}"
                />
              </div>
            </b-card-body>
          </div>
        </b-col>
      </b-row>
    </template>
  </v-wait>
</template>

<script>
import IcoStatistics from '@/components/mss_admin/dashboard/metrics/components/IcoStatistics';
import { handleServerErrorWithValidation } from '@/helpers/ToastedHelper';
import Api from '@/providers/Api';
import { HalfCircleSpinner } from 'epic-spinners';
import UsaMapChart from '@/components/dashboard/metrics/components/UsaMapChart';
import ChartBuilder from '@/components/survey/results/ChartBuilder';

export default {
  name: 'MssAdminIcoMetrics',
  components: {
    UsaMapChart,
    IcoStatistics,
    HalfCircleSpinner,
    ChartBuilder,
  },
  data: function () {
    return {
      icoStatistic: null,
      icoLocationStatistics: null,
      icoChartsResults: [],
    };
  },
  computed: {
    loaderId: function () {
      return `loading_${this.$options.name}`;
    },
  },
  created: function () {
    this.getMetricsData();
  },
  methods: {
    getMetricsData: async function () {
      this.$wait.start(this.loaderId);
      try {
        const fetchResults = await Promise.allSettled([
          Api.mssAdminGetIcoStatistics(),
          Api.mssAdminGetIcoLocationStatistics(),
          Api.mssAdminGetIcoValuesForDashboardCharts(),
        ]);
        if (fetchResults[0] && fetchResults[0].status === 'fulfilled')
          this.icoStatistic = fetchResults[0].value;
        else
          this.$toasted.error('Unable to upload ICO statistics.', {
            duration: 3000,
          });
        if (fetchResults[1] && fetchResults[1].status === 'fulfilled')
          this.icoLocationStatistics = fetchResults[1].value;
        else
          this.$toasted.error('Unable to upload Desired Location data.', {
            duration: 3000,
          });
        if (fetchResults[2] && fetchResults[2].status === 'fulfilled')
          this.icoChartsResults = fetchResults[2].value;
        else
          this.$toasted.error('Unable to upload ico charts.', {
            duration: 3000,
          });
      } catch (error) {
        handleServerErrorWithValidation(error, this.$toasted);
      } finally {
        this.$wait.end(this.loaderId);
      }
    },
  },
};
</script>

<style scoped></style>
